import React from 'react';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { HashRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';

const darkTheme = createTheme({ /* ... */ });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={darkTheme}>
    <HashRouter>
      <App />
    </HashRouter>
  </ThemeProvider>
);